<!--     <div>
      <div style="background-color: #f6f6f7; width: 100%;">
        <br><br>
        <div class="containers mt-5" style="padding-left: 15px; padding-right: 15px;">
          <h2 class="fw-bold" style="font-family: Montserrat, sans-serif;"><strong>CONTACT US!</strong> </h2>
          <div class="row mt-4">
            <div class="col-md-6">
              <div class="p-3 border bg-white" style="margin-bottom: 46px;">
                <h5 class="fw-bold"
                  style="font-size: 15px; font-family: Montserrat, sans-serif;font-weight: 800;margin-left: 12px;">
                  <strong>ADMISSIONS - SEGOVIA</strong>
                </h5>
                <p>
                  <a href="mailto:ieuadmissions@ie.edu"
                    style="text-decoration: none; color: #0d6efd;margin-left: 12px;font-size: 15px;"><i
                      class="bi bi-envelope" style="color: rgb(92, 91, 91);font-size: 16px;"></i>&nbsp;
                    ieuadmissions@ie.edu</a>
                </p>
                <p>
                  <a href="tel:+34921412428"
                    style="text-decoration: none; color: #0d6efd;margin-left: 12px;font-size: 15px;"><i
                      class="bi bi-telephone" style="color: rgb(92, 91, 91);font-size: 16px;"></i>&nbsp; +34 921 412
                    428</a>
                </p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="p-3 border bg-white" style="margin-bottom: 46px;">
                <h5 class="fw-bold"
                  style="font-size: 15px; font-family: Montserrat, sans-serif;font-weight: 800;margin-left: 12px;">
                  <strong>ADMISSIONS - MADRID</strong>
                </h5>
                <p>
                  <a href="mailto:ieuadmissions@ie.edu"
                    style="text-decoration: none; color: #0d6efd;margin-left: 12px;font-size: 15px;"><i
                      class="bi bi-envelope" style="color: rgb(92, 91, 91);font-size: 16px;"></i>&nbsp;
                    ieuadmissions@ie.edu</a>
                </p>
                <p>
                  <a href="tel:+34915689620"
                    style="text-decoration: none; color: #0d6efd;margin-left: 12px;font-size: 15px;"><i
                      class="bi bi-telephone" style="color: rgb(92, 91, 91);font-size: 16px;"></i> &nbsp; +34 915689620</a>
                </p>
              </div>
            </div>
            <br><br><br><br><br><br>
          </div>
        </div>

 
      </div>
    </div>
    <div class="containers mt-5" style="background-color: #f4f4f4;">
      <div class="row g-4" style="padding: 1%;margin-top: -65px;">
        <div class="col-md-6" style="display: flex; justify-content: left;gap: 20;margin-bottom: 46px;margin-top: 30px;">
          <div
            style="border: 5px solid white; padding: 20px; width: 100%; text-align: left;background-color: white;">
            <h6 style="font-weight: bold;color: black; font-size: 15px;"><strong> BOOK A CALL WITH ME</strong>
            </h6>
            <button
              style="background-color: rgb(7, 7, 105); color: white; border: none; padding: 10px 20px; width: 100%; font-weight: bold;height: 57px;">
              BOOK A CALL
            </button>
          </div>
        </div>
        <div class="col-md-6" style="display: flex; justify-content: left;gap: 20;margin-bottom: 46px;margin-top: 30px;">
          <div
            style="border: 5px solid white; padding: 20px; width: 100%; text-align: left;background-color: white;">
            <h6 style="font-weight: bold;color: black; font-size: 15px;"><strong> CHAT WITH ME</strong></h6>
            <button
              style="background-color: navy; color: white; border: none; padding: 10px 20px; width: 100%; font-weight: bold;height: 57px;">
              CLICK TO WHATSAPP
            </button>
          </div>
        </div>
      </div>
    </div>
 -->

 <div >
  <div style="background-color: #f6f6f7; width: 100%; padding-bottom: 5%;">&nbsp;
  <h2 class="fw-bold mb-4" style="font-family: Montserrat, sans-serif; text-align: left; font-size: 35px; padding: 0px 39px; font-weight: 800;">CONTACT US!</h2>
  
  <div class="row g-4 mt-4" style="padding: 30px;">
  <div class="col-12 col-md-6" style="margin-bottom: 16px;">
  <div class="bg-white p-4 h-100 ">
  <h2 class="fw-bold" style="font-weight: 900; font-size: 15px; font-family: Montserrat, sans-serif;"><strong>ADMISSIONS </strong></h2>
  
  <p style="margin-top: 15px;">
    <a href="mailto:ieuadmissions@ie.edu"
     style="text-decoration: none; color: #2b2d79; font-size: 15px;width: 45%;">
     <i class="bi bi-envelope" style="color: rgb(92, 91, 91); font-size: 15px; font-family: PT Serif,serif; font-weight: 500;"></i>&nbsp;
     admissions@onesb.edu.in
    </a>
    </p>
  
  <p>
    <a href="tel:+34921412428" 
    style="text-decoration: none; color: #2b2d79; font-size: 15px; font-family: PT Serif,serif;">
    <i class="bi bi-telephone" style="color: rgb(92, 91, 91); font-size: 15px; font-weight: 500;"></i>
    &nbsp; +91 9035065340 </a>
  </p>
  </div>
  </div>
  
  <div class="col-12 col-md-6" style="margin-bottom: 16px;">
  <div class="bg-white p-4 h-100 ">
  <h2 class="fw-bold" style="font-weight: 900; font-size: 15px; font-family: Montserrat, sans-serif;"><strong>ACADEMICS</strong></h2>
  
  <p style="margin-top: 15px;">
    <a href="mailto:ieuadmissions@ie.edu"
     style="text-decoration: none; color: #2b2d79; font-size: 15px;width: 45%;">
     <i class="bi bi-envelope" style="color: rgb(92, 91, 91); font-size: 15px; font-family: PT Serif,serif; font-weight: 500;"></i>&nbsp;
     admissions@onesb.edu.in
    </a>
    </p>
  
    <p>
      <a href="tel:+34921412428" 
      style="text-decoration: none; color: #2b2d79; font-size: 15px; font-family: PT Serif,serif;">
      <i class="bi bi-telephone" style="color: rgb(92, 91, 91); font-size: 15px; font-weight: 500;"></i>
      &nbsp; +91 9035065340 </a>
    </p>
  </div>
  </div>
  </div>
  
  <div class="row g-4" style="padding: 0 28px;">
    <div class="col-12 col-md-6 mb-4">
      <div class="bg-white p-4 h-100">
        <h5 style="font-weight: 800;">HAVE A CALL WITH ME</h5>
        <a href="tel:+91 9035065340"
           class="btn w-100 mt-3"
           style="background-color:#4235e0; color: white; font-weight: 800; height: 40px;border-radius: 0%;">
          CLICK TO CALL
        </a>
      </div>
    </div>
  
    <div class="col-12 col-md-6 mb-4">
      <div class="bg-white p-4 h-100">
        <h5 style="font-weight: 800;">CHAT WITH ME</h5>
        <a href="https://wa.me/919035065340"
        target="_blank"
        class="btn w-100 mt-3"
        style="background-color: #4235e0; color: white; font-weight: 800; height: 40px; border-radius: 0%;">
        CLICK TO WHATSAPP
     </a>
     
      </div>
    </div>
  </div>
  
  </div>
  </div>





<div class="text-center" style="background-color: #032d50; padding: 40px 0;">
  <h3 style="color: white; font-weight: bold; text-align: center;">FOLLOW US</h3>
  <div class="d-flex justify-content-center align-items-center mt-3" style="gap: 25px; font-size: 24px; color: white;">
    <a href="https://www.instagram.com/oneschoolofbusiness" style="color: white;"><i class="bi bi-instagram"></i></a>
    <a href="https://in.linkedin.com/in/one-school-of-business" style="color: white;"><i class="bi bi-linkedin"></i></a>
    <a href="https://www.facebook.com/ONESBBNGLR/" style="color: white;"><i class="bi bi-facebook"></i></a>
    <a href="https://www.youtube.com/channel/UCLbMueEZYVMSd1mF30vLr7Q" style="color: white;"><i class="bi bi-youtube"></i></a>
 <!--    <a href="#" style="color: white;"><i class="bi bi-twitter-x"></i></a> -->

    <!-- <a href="#" style="color: white;"><i class="bi bi-mic"></i></a> -->
  </div>
</div>

<footer class="footer pt-5 ">
  <div class="container">
    <div class="footer-column">
      <h3>Onesb Bangalore :</h3>
      <p style="font-size: 15px; font-family: Montserrat, sans-serif;">ONESB - One School of Business was founded with a quest to educate and prepare a whole new generation of students to excel in the technologically advanced, globally complex, dynamic, fast paced world of business situated in Bangalore - One of the world’s top start-up hubs</p>
      
    </div>
    
    <div class="footer-column" style=" font-family: Montserrat, sans-serif;">
      <h3>Contact Us</h3>
      <p>#23/1, Nagawara, Bangalore - 560 045, Karnataka, India</p>
      <p>Admission Hotline: <a href="tel:+919035065340">+91 9035065340</a></p>
<p>Toll Free Number: <a href="tel:+919035065340">+91 9035065340</a></p>

      
      <div class="footer-column" style="margin-top: 40px;">
        <iframe 
        src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d124383.27780966228!2d77.53822224474132!3d13.037108477775316!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3bae17dacaaaa051%3A0x4e87ce994489e8a9!2sWard%20No.23%2C%20BBMP%2C%2023%2F1%2C%20Govindapura%2C%20Nagawara%2C%20Bengaluru%2C%20Karnataka%20560045!3m2!1d13.0371355!2d77.6206255!5e0!3m2!1sen!2sin!4v1741851684576!5m2!1sen!2sin" 
        width="200" height="150" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0">
    </iframe>
      </div>
       
      <div class="social-icons" style="margin-top: 50px;">
     
        <a href="https://www.facebook.com/ONESBBNGLR"><img height="20px" width="20px" src="https://img.icons8.com/ios-glyphs/30/FFFFFF/facebook.png"
            alt="Facebook"></a>
        <a href="https://www.linkedin.com/in/one-school-of-business/"><img height="20px" width="20px" src="https://img.icons8.com/ios-glyphs/30/FFFFFF/linkedin.png"
            alt="LinkedIn"></a>
        <a href="https://www.youtube.com/@onesb1"><img height="20px" width="20px" src="https://img.icons8.com/ios-glyphs/30/FFFFFF/youtube.png"
            alt="YouTube"></a>
        <a href="https://www.instagram.com/oneschoolofbusiness/"><img height="20px" width="20px" src="https://img.icons8.com/ios-glyphs/30/FFFFFF/instagram.png"
            alt="Instagram"></a>
      </div>
    </div>
    <div class="footer-column">
      <h3>USEFUL LINKS</h3>
      <ul style="display: flex;flex-direction: column; font-family: Montserrat, sans-serif;">
        <li><a href="https://www.onesb.edu.in/grievance">Grievance Cell</a></li>
        <li><a href="https://onesb.edu.in/assets/img/MD-2022.pdf" target="_blank">Mandatory Disclosures</a></li>
        <li><a href="https://www.onesb.edu.in/feedback">Feedback Facility</a></li>
        <li><a href="https://www.onesb.edu.in/aicte-approval">AICTE APPROVAL</a></li>
        <li><a href="https://www.onesb.edu.in/research">Research </a></li>
        <li><a href="https://www.onesb.edu.in/out-research-program">Out Reach Program</a></li>
        <li><a href="https://www.onesb.edu.in/infrasturture">Infrastructure</a></li>
        <li><a href="https://www.onesb.edu.in/alumini">Alumni</a></li>
        <li><a href="https://www.onesb.edu.in/commitee">Committee</a></li>
        <li><a href="https://www.onesb.edu.in/contact-us">Contact</a></li>
        <li><a href="https://www.onesb.edu.in/privacy-policy">Terms & Conditions</a></li>

        
      </ul>
    </div>
    <div class="footer-column" style="font-family: Montserrat, sans-serif;">
      <h3>LIBRARY RESOURCES</h3>
      <ul style="display: flex;flex-direction: column;">
        <li><a href="https://www.onesb.edu.in/library">Onesb E-Library</a></li>
        <li><a href="https://www.onesb.edu.in/sage-journals">Sage Journals</a></li>
        <li><a href="http://localhost:4200/blog">Blogs</a></li>
        <li><a href="https://www.onesb.edu.in/iic">IIC</a></li>
        <li><a href="https://www.onesb.edu.in/iqac">IQAC</a></li>
       <!--  <li><a href="#">Terms & Conditions</a></li> -->
       
      </ul>
    </div>
  </div>
  <div class="footer-bottom mt-3" style="background-color: #000;">
    <p style="color: white;font-family: Montserrat, sans-serif;">&copy; 2024 Onesb Bangalore.</p>
  </div>
</footer>